/**
 * Header chrome: announcement-bar dismiss, scroll-aware show/hide + scrolled
 * state, mobile menu, search overlay.
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;

    var bar = header.querySelector('[data-announcement-bar]');
    var dismissBtn = header.querySelector('[data-announcement-dismiss]');
    var menuToggle = header.querySelector('[data-menu-toggle]');
    var mobileMenu = header.querySelector('[data-mobile-menu]');
    var searchToggle = header.querySelector('[data-search-toggle]');
    var searchClose = header.querySelector('[data-search-close]');
    var searchOverlay = header.querySelector('[data-search-overlay]');

    if (dismissBtn && bar) {
      dismissBtn.addEventListener('click', function () { bar.classList.add('is-dismissed'); });
    }

    function closeOverlays() {
      header.classList.remove('is-menu-open', 'is-search-open');
      if (mobileMenu) { mobileMenu.classList.remove('is-open'); mobileMenu.setAttribute('aria-hidden', 'true'); }
      if (searchOverlay) { searchOverlay.classList.remove('is-open'); searchOverlay.setAttribute('aria-hidden', 'true'); }
      document.documentElement.style.overflow = '';
    }

    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function () {
        var opening = !header.classList.contains('is-menu-open');
        closeOverlays();
        if (opening) {
          header.classList.add('is-menu-open');
          mobileMenu.classList.add('is-open');
          mobileMenu.setAttribute('aria-hidden', 'false');
          document.documentElement.style.overflow = 'hidden';
        }
      });
    }

    if (searchToggle && searchOverlay) {
      searchToggle.addEventListener('click', function () {
        closeOverlays();
        header.classList.add('is-search-open');
        searchOverlay.classList.add('is-open');
        searchOverlay.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        var input = searchOverlay.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 100);
      });
    }
    if (searchClose) searchClose.addEventListener('click', closeOverlays);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeOverlays();
    });

    /* scroll: hide-on-scroll-down, show-on-scroll-up, backdrop past 80px */
    var lastY = window.scrollY;
    var ticking = false;
    function onScroll() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 80);
      if (y > lastY && y > 160) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  });
})();
